module.exports = __webpack_public_path__ + "static/img/ycks4.1913519.png";


//////////////////
// WEBPACK FOOTER
// ./src/components/commonproblem/appopen/appopen/ycks4.png
// module id = K1hi
// module chunks = 0